<template>
  <nx-bform
    ref="form"
    @submit="onSubmit"
    class="e-registration-professional-register-form"
  >
    <h5>
      {{ $t("title") }}
    </h5>
    
    <p class="text-muted">
      {{ $t("titleDesc") }}
    </p>
    <!-- <nx-bform-server-errors /> -->
    <div class="mb-2" style="color:#dc3545;font-size: 80%;margin-top: 0.25rem;">
      {{errorMsg}}
    </div>
    <RegistrationHKIDNumberFormGroup
      label-cols="2"
      label-align="right"
      required
      v-model="form.idNo"
      :disabled="hkidDisable"
    />

    <!--<RegistrationDateOfBirthFormGroup
      label-cols="2"
      label-align="right"
      required
      v-model="form.dateOfBirth"
    />-->

    <ManageCertProfessionalFormGroup :is-disable="!isHKIDFormat(form.idNo)" label-align="right" :hkid="form.idNo" :guid="guid" @setHKID="setHKID" label-cols="2" />

    <CaptchaFormGroup
      label-cols="2"
      label-align="right"
      v-model="form.captcha"
      @change-token="form.captchaToken = $event.token"
      required
    />
    <hr />
    <ERegistrationPublicTermCond v-model="accepted" />
    <div class="mb-2" style="color:#dc3545;font-size: 80%;margin-top: 0.25rem;">
      {{errorMsg}}
    </div>
    <b-button type="submit" class="bd-button mr-2" v-t="'send'" />
    <b-button variant="danger" @click="resetForm" v-t="'cancel'" />
  </nx-bform>
</template>

<script>
import { assign } from "lodash";
import { EshApi,MemberRegistrationApi } from "@/api";
import moment from "moment";
import { FileUtil } from "nx-libs";
import { CommonUtil } from "@/utils";
import ERegistrationPublicTermCond from "../ERegistrationPublicTermCond";
import RegistrationHKIDNumberFormGroup from "@/forms/registration/RegistrationHKIDNumberFormGroup";
//import RegistrationDateOfBirthFormGroup from "@/forms/registration/RegistrationDateOfBirthFormGroup";
import RegistrationESignatureFormGroup from "@/forms/registration/RegistrationESignatureFormGroup";
import CaptchaFormGroup from "@/forms/common/CaptchaFormGroup";
import ManageCertProfessionalFormGroup from '@/pages/manage-cert/components/ManageCertProfessionalFormGroup.vue';
import { v4 as uuidv4 } from 'uuid';
import { translateResponseError } from "@/utils/translate-response-error";

export default {
  components: {
  ERegistrationPublicTermCond,
    RegistrationHKIDNumberFormGroup,
    ManageCertProfessionalFormGroup,
    //RegistrationDateOfBirthFormGroup,
    RegistrationESignatureFormGroup,
    CaptchaFormGroup
  },
  data() {
    return {
      form: this.getForm(),
      accepted: false,
      hkidDisable:false,
      guid:uuidv4(),
      autoLogout:true,
      errors: [],
      errorMsg: ''
    };
  },
  computed: {
    profOptions() {
      return [
        { text: "Authorized Person", value: "AP" },
        { text: "Registration Structure Engineer", value: "RSE" },
        { text: "Registered Geotechnical Engineer", value: "RGE" }
      ];
    }
  },
  mounted() {
    this.$watch(
      () => {
        this.errors = this.$refs.form.observer.errors['server-errors']
    })
    this.$nextTick(() => {
      // 選取所有 <fieldset> 元素
      const fieldsets = document.querySelectorAll('fieldset');
      // 遍歷每個 <fieldset>
      fieldsets.forEach(fieldset => {
        // 查找 <fieldset> 中的 <legend>
        let legend = fieldset.querySelector('legend');
        // 如果 <legend> 不存在，創建並插入
        if (!legend) {
          legend = document.createElement('legend');
          legend.textContent = fieldset.getAttribute('label') || ''; // 使用 <fieldset> 的 label 屬性作為文本
          legend.style.all = 'unset'; // 重置所有內聯樣式
          legend.style.display = 'inline-block'; // 確保 <legend> 是塊級元素
          legend.style.fontWeight = 'bold'; // 添加適當的字重
          legend.style.marginBottom = '0.5rem'; // 添加下邊距以避免緊貼其他內容
          fieldset.insertBefore(legend, fieldset.firstChild);
        } else if (fieldset.firstElementChild !== legend) {
          // 如果 <legend> 存在但不是第一個子元素，將其移動到第一個位置
          fieldset.insertBefore(legend, fieldset.firstChild);
        }
        // 處理空白的 <legend>
        if (!legend.textContent.trim()) {
          legend.style.display = 'none'; // 隱藏空白的 <legend>
        }
      })


      // 選取頁面中所有的 <legend> 元素
      const legends = document.querySelectorAll('legend');
      // 遍歷每個 <legend>
      legends.forEach((legend) => {
        // 如果 <legend> 包含 class "text-right"，則刪除該 class
        if (legend.classList.contains('text-right')) {
          legend.classList.remove('text-right');
        }
      })



      // 查找页面中所有的 <fieldset> 元素
      // const fieldsets = document.querySelectorAll('fieldset');

      // 遍历每个 <fieldset>
      fieldsets.forEach((fieldset) => {
        // 获取 <fieldset> 下的 <legend> 元素
        const legend = fieldset.querySelector('legend');

        // 如果 <legend> 存在，获取其文本内容
        if (legend) {
          const legendText = legend.textContent.trim(); // 去除多余空格

          // 查找 <fieldset> 下的所有 <input> 元素
          const inputs = fieldset.querySelectorAll('input');

          // 遍历每个 <input>，为其添加 aria-label 属性
          inputs.forEach((input) => {
            input.setAttribute('aria-label', legendText);
            input.setAttribute('title', legendText);
          })
        }
      })


      const link = document.querySelector('a[aria-disabled]')
      if (link) {
        link.removeAttribute('aria-disabled')
      }
    })
  },
  watch: {
    errors(errors) {
      // document.getElementsByClassName('main-content')[0].scrollTop = 0;
      if (errors){
        $('.form-control.is-invalid:first')[0].offsetParent.scrollIntoView({behavior: 'smooth'});
      }
    },
  },
  async created(){

  },  
  methods: {
    getForm() {
      return {
        idDoc: "hkid",
        //dateOfBirth: "",
        eCert: null,
        captcha: "",
        captchaToken: ""
      };
    },
    isHKIDFormat(hkid)
    {
      return CommonUtil.isHKIDFormat(hkid);
    },
    resetForm() {
      this.form = this.getForm();
      this.$refs.form.reset();
      this.$router.go(-1);
    },
    async onSubmit(evt) {
      this.$spinner.show();
      const { form } = this;
      const registry = {
        hkidNumber: form.idNo,
        //dateOfBirth: moment.utc(form.dateOfBirth).toISOString(),
        memberCertificationGUID:this.guid
      };
      try {
        const data = await MemberRegistrationApi.activate(
          registry,
          form.captchaToken
        );
        this.$router.push({
          name: "ERegistrationProfessionalRegister",
          params: {
            info: assign(data.data)
          }
        });
      } catch(ex) {
        if (ex.response && ex.response.data != null) {
          this.errorMsg = translateResponseError(this, ex.response.data);
        }
        throw ex;
      }
      finally
      {
        this.$spinner.hide();
      }
      
    },
    setHKID(isDisable)
    {
      this.hkidDisable = isDisable;
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep legend{
  text-align: left !important;
}
</style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/locales/responseMsg.locale"></i18n>

<i18n>
{
  "en": {
    "title": "Activating a user account of Electronic Submission Hub",
    "titleDesc": "If you are an authorized person/ registered structural engineer/ registered geotechnical engineer or an authorized signatory of registered general building contractors/registered specialist contractor under the Buildings Ordinance and want to become a user of ESH, please complete the following application form. All fields with (*) are mandatory."
  },
  "zh_hk": {
    "title": "啟用成為電子資料呈交及處理系統的用戶",
    "titleDesc": "假如你是《建築物條例》下的 認可人士/註冊結構工程師/註冊岩土工程師/註冊一般建築承建商/註冊專門承建商，並要成為電子資料呈交及處理系統的用戶，請填寫以下申請表格。帶（*）的所有字段均為必填項。"
  },
  "zh_cn": {
    "title": "申请作为电子提交中心的专业用户激活",
    "titleDesc": "假如你是《建筑物条例》下的 认可人士/注册结构工程师/注册岩土工程师/注册一般建筑承建商/注册专门承建商，并要成为电子资料呈交及处理系统的用户，请填写以下申请表格。带（*）的所有字段均为必填项。"
  }
}
</i18n>
